// extracted by mini-css-extract-plugin
module.exports = {"searchTitle":"search_searchTitle__2ZRTb","noResult":"search_noResult__NaSRJ"};